import * as React from 'react';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import 'classnames';
import '@grandvisionhq/forms';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '../../../../../types/product.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/elements';
import '@grandvisionhq/inventory';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/common';
import '../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '../../../../../hooks/use-product-view-history.js';
import '../../../../../slots/context.js';
import { ProductDetailCTA } from '../../../components/CTAs/ProductDetailCTA/ProductDetailCTA.js';
import '@grandvisionhq/content';
import { useFramesEcommContext } from '../../context/FramesEcommContext.js';

const FramesCTA = ()=>{
    const { activeVariant: { sku  } ,  } = useProductData();
    const { productAction , handleConfiguratorOpen , selectedOffering  } = useFramesEcommContext();
    const handleConversionEvent = React.useCallback(()=>{
    // @TODO: handle conversion event in #
    // Possibly we will need to add this to products-details-v2
    }, []);
    const onAddToCartSuccess = React.useCallback(()=>{
    // @TODO: in a future story, this is where the data analytics will be triggered
    }, []);
    return /*#__PURE__*/ React.createElement(ProductDetailCTA, {
        action: productAction,
        handleConfiguratorOpen: handleConfiguratorOpen,
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: {
            activeSku: sku,
            offeringSku: selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.sku,
            bundleLineItemSkus: selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.bundledProductSkus,
            onSuccess: onAddToCartSuccess
        }
    });
};

export { FramesCTA };
//# sourceMappingURL=FramesCTA.js.map
